<footer class="bg-dark sticky-footer">
  <div class="container my-auto">
    <div class="text-center my-auto copyright"><span>Copyright © L'administration multiclient {{currentYear}}</span></div>
  </div>
</footer>
